import { z } from 'zod';

const workflowSettingsSchema = z.object({
  disableStateHistory: z.boolean().optional()
});

export const isStateHistoryDisabled = (settings: unknown): boolean => {
  const parsed = workflowSettingsSchema.safeParse(settings);
  return parsed.success && parsed.data.disableStateHistory === true;
};
